import { connect } from 'react-redux';

import MatchPlayer from './MatchPlayer';

const mapStateToProps = () => ({});
const mapDispatchToProps = { };

export default connect(mapStateToProps, mapDispatchToProps)(MatchPlayer);
